import React from 'react';
import PropTypes from 'prop-types';

import { AnnouncementBanner, Link, Button } from '..';

import './WebinarBanner.scss';

const WebinarBanner = ({ key, utmSource, newsletter, onClose }) => {
  let url = newsletter ? '/newsletter/' : 'https://app.livestorm.co/bldr/designing-a-premium-online-booking-experience-for-luxury-travel?utm_source=boldare.com&utm_medium=referral&utm_campaign=why-design-matters';

  if (utmSource) {
    url += `&utm_content=${utmSource}`;
  }

  return (
    <div
      className={`webinar-banner-wrapper ${newsletter && 'webinar-banner__newsletter'}`}
    >
      <AnnouncementBanner additionalClass="webinar-banner" onClose={onClose}>
        <div className="webinar-banner__title">
          {newsletter ? 'Newsletter' : 'Webinar'}
        </div>
        <div className="webinar-banner__separator" />
        <div className="webinar-banner__subtitle">
          {newsletter ?
            'Check out Digital Shift Newsletter on digital products, design and Work 4.0 curated by our co-CEOs' : 'Designing a premium online booking experience for luxury travel'
          }
        </div>
        <div className="webinar-banner-join">
          {!newsletter && (
            <div className="webinar-banner-join__info">
              <strong className="webinar-banner-join__info--important">
                January 22nd
              </strong>
              10:00 am (CET)
            </div>
          )}
          <Link
            id={`webinar-banner-${key}`}
            to={url}
            additionalClass="webinar-banner-join__button"
          >
            <Button
              color="white"
              id="webinar-join-button"
            >
              {newsletter ? 'Subscribe' : 'Register'}
            </Button>
          </Link>
        </div>
      </AnnouncementBanner>
    </div>
  );
};

WebinarBanner.propTypes = {
  key: PropTypes.string.isRequired,
  utmSource: PropTypes.string,
  onClose: PropTypes.func,
  newsletter: PropTypes.bool,
};

WebinarBanner.defaultProps = {
  utmSource: null,
  onClose: null,
  newsletter: false,
};

export default WebinarBanner;
